import axios from 'axios'

//axios.defaults.baseURL = 'https://dev-api-multicargo.herokuapp.com/'
axios.defaults.baseURL = 'http://multicargo-api-1564163180866.azurewebsites.net/'
let userToken = window.localStorage.getItem('userToken')
axios.defaults.headers.common['Token'] = userToken !== null ? userToken : ''
export default axios
